import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import RevenueReportingCard from '../../Revenue/RevenueReportingCard';
import RevenueReportingPeriod from '../../Revenue/RevenueReportingPeriod';

export default function RevenueReportPage({ get_properties_endpoint }) {
	return (
		<div className="mt-12 mb-12 text-xl md:text-2xl">
			<div className="flex items-center mb-3 text-gray-400">
				<Link to="/dashboard" className="hover:underline mr-3">
					Dashboard
				</Link>
				<i className="text-gray-400 fa fa-chevron-right mr-3" aria-hidden="true" />
			</div>
			<div className="font-semibold">Report Revenue</div>
			<RevenueReportingPeriod />
			<RevenueReportingCard get_properties_endpoint={get_properties_endpoint} />
		</div>
	);
}

RevenueReportPage.propTypes = {
	get_properties_endpoint: PropTypes.string.isRequired
};
